export default __webpack_public_path__ + "static/Saved-1d6667a831ff9ad13fc2642be90d151b.png";